import { AxiosError } from "axios";

export type FlattenObjectKeys<T extends Record<string, unknown>, Key = keyof T> = Key extends string ? T[Key] extends Record<string, unknown> ? `${Key}.${FlattenObjectKeys<T[Key]>}` : `${Key}` : never

export const cleanObject = (object: any | Array<any>) => {
    Object
        .entries(object)
        .forEach(([k, v]) => {
            if (v && v instanceof Object) { cleanObject(v); }
            if (v && v instanceof String && v.length === 0) { object[k] = undefined; }
            if (v === null) { object[k] = undefined; }
        });
    return object;
}

export const flattenObject = (obj: Record<string, any>, prefix = "") =>
    Object.keys(obj).reduce<Record<string, any>>((acc, k) => {
    const pre = prefix.length ? prefix + "." : "";
    if (typeof obj[k] === "object")
        Object.assign(acc, flattenObject(obj[k], pre + k));
    else acc[pre + k] = obj[k];
    return acc;
}, {});

export const erroredAxiosResponse = (response: any, defaultMessage: string) : string => {
    var errorMessage = defaultMessage;
    if (response instanceof AxiosError) {
        if (response.response?.data.errors) {
            const {full_messages} = response.response?.data.errors;
            if (full_messages) { errorMessage = full_messages.join(', '); }
        }
    }
    return errorMessage;
}

export const truncate = (str: string, n: number) => {
    return (str.length > n) ? str.slice(0, n-6) + "(...)" + str.slice(-6) : str;
};